<template>
    <div class="country-selector-inline">
        <a-select
            mode="multiple"
            v-model="selectedCountry"
            style="width: 100%"
            :filter-option="false"
            @search="getCountriesBySearch"
            @change="() => getCountriesBySearch()"
            :not-found-content="fetching ? undefined : null"
        >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="item of items" :key="item.key" :value="item.key">
                {{ item.value }}
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "CountrySelectorInline",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        fetching: false,
        selectedCountry: [],
        items: [],
        searchTimeout: null,
    }),
    mounted() {
        if (Array.isArray(this.value)) this.selectedCountry = this.value;
        this.getCountriesBySearch();
    },
    methods: {
        ...mapActions({
            getContactByField: "visitor/getContactByField",
        }),
        getCountriesBySearch(query) {
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.fetching = true;
                this.getContactByField({ field: "country", query }).then((items) => {
                    this.items = this.$_.uniq(items).map((item) => ({
                        key: item,
                        value: item,
                    }));
                    this.fetching = false;
                });
            }, 500);
        },
    },
    watch: {
        selectedCountry() {
            this.$emit("input", this.selectedCountry);
        },
        value() {
            this.selectedCountry = this.value;
        },
    },
};
</script>
